<script>
    export let id = id;
</script>
<div id={id} class="vec-p-5">
    <slot></slot>
</div>